<template>
  <div>
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มไอพีปริ้นเตอร์เรียบร้อย</v-alert>
      <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขไอพีปริ้นเตอร์เรียบร้อย</v-alert>
      <v-alert type="error" class="alert_success" v-if="alert_show_delete === true">ลบไอพีปริ้นเตอร์เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" sm="12" md="4" lg="4" xl="4">
            <v-card elevation="0" class="pa-3">
              <v-form ref="printer" @submit.prevent="create_printer()">
                <div class="">
                  <v-text-field clearable label="Printer name" :rules="[v => !!v || 'กรุณากรอกชื่อ']" v-model="printer_name" outlined></v-text-field>
                </div>
                <div class="">
                  <v-text-field clearable label="Printer IP" :rules="[v => !!v || 'กรุณากรอกเลขที่ไอพี']" v-model="printer_ip" outlined></v-text-field>
                </div>
                <div>
                  <v-btn color="#038cc1" class="titlefont_printerconfig white--text" width="100%" height="50" type="submit">
                    บันทึก
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="8" sm="12" md="8" lg="8" xl="8">
            <div v-if="loading_page === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-card elevation="2" class="pa-3">
                <v-data-table :headers="headers" item-key="index" :items="data_list" :items-per-page="perPage" mobile-breakpoint="0">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td>{{dataDetail.index + 1}}</td>
                      <td>{{dataDetail.item.name}}</td>
                      <td>{{dataDetail.item.IP_address}}</td>
                      <td class="text-center">
                        <span class="edit_data_printer" @click="edit_printer(dataDetail.item.id)" title="แก้ไข">
                          <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                        </span>
                        <span class="edit_data_printer pl-3" @click="delete_printer(dataDetail.item.id)" title="ลบ">
                          <v-icon dark right color="grey">mdi-delete-outline</v-icon>
                        </span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Printer_ip_config",
  data() {
    return {
      loading_page: false,
      perPage: -1,
      alert_show_add: false,
      alert_show_edit: false,
      alert_show_delete: false,
      printer_id: null,
      printer_name: null,
      printer_ip: null,
      headers: [
        {
          text: '#',
          value: 'id',
          fixed: true,
          width: '150px',
        },
        {
          text: 'Printer name',
          value: 'name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'Printer code',
          value: 'IP_address',
          fixed: true,
          width: '300px',
        },
        {
          text: 'Tools',
          value: '',
          fixed: true,
          sortable: false,
          width: '200px',
          align: 'center',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      const config = {
        headers: {
          'Authorization': `Bearer ${this.$store.state.token}`,
        }
      }
      HTTP.get('/printer_all',config)
          .then((res) => {
            if (res.data.successful === true) {
              this.loading_page = false
              this.data_list = res.data.prints
            }
          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    edit_printer(id) {
      const config = {
        headers: {
          'Authorization': `Bearer ${this.$store.state.token}`,
        }
      }
      HTTP.get('printer_edit/' + id, config)
          .then((res) => {
            if (res.data.successful === true) {
              this.printer_id = res.data.printer.id
              this.printer_name = res.data.printer.name
              this.printer_ip = res.data.printer.IP_address
            }
          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    create_printer() {
      let config = {
        headers: {
          'Authorization': `Bearer ${this.$store.state.token}`,
        }
      }
      if(this.$refs.printer.validate()) {
        if(this.printer_id !== null) {
          HTTP.post('/printer_update/' + this.printer_id, config)
              .then((res) => {
                if (res.data.successful === true) {
                  this.alert_show_edit = true
                  setTimeout(() => this.alert_show_edit = false, 3000)
                  this.get_data()
                }
              }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
        }
        else {
          HTTP.post('/create_printer/', {
            name: this.printer_name,
            IP_address: this.printer_ip,
          }, config)
              .then((res) => {
                if (res.data.successful === true) {
                  this.alert_show_add = true
                  setTimeout(() => this.alert_show_add = false, 3000)
                  this.get_data()
                }
              }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
        }
      }
    },
    delete_printer(id) {
      let config = {
        headers: {
          'Authorization': `Bearer ${this.$store.state.token}`,
        }
      }
      HTTP.post('/printer_delete/' + id, config)
          .then((res) => {
            if (res.data.successful === true) {
              this.alert_show_delete = true
              setTimeout(() => this.alert_show_delete = false, 3000)
              this.get_data()
            }
          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.titlefont_printerconfig {
  font-size: 22px !important;
}
.edit_data_printer {
  cursor: pointer;
}
</style>
